import { render, staticRenderFns } from "./package-other-tab.vue?vue&type=template&id=aa9640be&scoped=true"
import script from "./package-other-tab.vue?vue&type=script&lang=js"
export * from "./package-other-tab.vue?vue&type=script&lang=js"
import style0 from "./package-other-tab.vue?vue&type=style&index=0&id=aa9640be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa9640be",
  null
  
)

export default component.exports